
import React from "react";
import Hero from "./home/Hero";
import Intro from "./home/Intro";
import Sponsors from "./home/Sponsors";
import Trophies from "./home/Trophies";
import TeamTiles from "./home/TeamTiles";
import StoreSplit from "./home/StoreSplit";
import LatestMatches from "./home/LatestMatches";
import GalleryPreview from "./home/GalleryPreview";
import { ACHIEVEMENTS } from "../data";
import { isPageVisible } from "../helpers";
import { BaseService, IGallery, IProfileWebsite, ITeamHistory, ITournamentEditionMatch, OmneHostService, SanitizedResponse } from "../../../../services";

export interface HomeProps {
    basePath: string;
    publicId: string;
    website: IProfileWebsite;
}

function Home({ website, basePath, publicId }: HomeProps) {

    const omnehostService = OmneHostService.getInstance();
    const [gallery, setGallery] = React.useState<IGallery[]>([]);
    const [matches, setMatches] = React.useState<ITournamentEditionMatch[]>([]);
    const [teamHistories, setTeamHistories] = React.useState<ITeamHistory[]>([]);

    React.useEffect(fetchInformation, [website]);

    return (<>
        <Hero website={website} basePath={basePath} />
        <Intro website={website} teamHistories={teamHistories} />
        {isPageVisible(website, "ACHIEVEMENTS") && (<Trophies website={website} basePath={basePath} achievements={ACHIEVEMENTS.slice(0, 6)} />)}
        {(isPageVisible(website, "SCHEDULE") && website.home_settings?.show_schedules !== false) && (<LatestMatches basePath={basePath} publicId={publicId} matches={matches} />)}
        {isPageVisible(website, "MERCH") && (<StoreSplit website={website} basePath={basePath} />)}
        {isPageVisible(website, "TEAM_HISTORY") && (<TeamTiles basePath={basePath} teamHistories={teamHistories} />)}
        {website.home_settings?.show_sponsors && (<Sponsors sponsors={website.sponsors ?? []} />)}
        {(isPageVisible(website, "GALLERY") && website.home_settings?.show_top_gallery !== false) && (<GalleryPreview basePath={basePath} gallery={gallery} />)}
    </>);

    function fetchInformation() {
        const username = website.member.username;
        if (isPageVisible(website, "GALLERY")) {
            omnehostService.queryMemberGallery(username, {
                size: 12,
                sort: "updated_at,DESC",
            }).then(({ content }: SanitizedResponse<IGallery>) => {
                setGallery(content ?? []);
            }).catch(BaseService.reportError);
        }
        if (isPageVisible(website, "SCHEDULE")) {
            omnehostService.queryMemberSchedule(username, {
                size: 5,
                sort: ["start_date,ASC", "status,ASC"],
            }).then(({ content }: SanitizedResponse<ITournamentEditionMatch>) => {
                setMatches(content ?? []);
            }).catch(BaseService.reportError);
        }
        omnehostService.queryMemberTeamHistory(username, {
            size: 10,
            sort: ["updated_at,ASC", "status,ASC"],
        }).then(({ content }: SanitizedResponse<ITeamHistory>) => {
            setTeamHistories(content ?? []);
        }).catch(BaseService.reportError);
    }
}

export default Home;
